import { TGlobalEmailSettingSchema } from '@/schemas/global-email-setting/global-email-setting.schema';
import { TCustomQueryProps } from '@/type/hooks.types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getFirstGlobalEmailSetting,
  upsertGlobalEmailSetting,
} from '@/api/global-email-setting/global-email-setting';
import { notify } from '@/utils/toast.utils';
import { NOTIFY } from '@/utils/constant.utils';
import { ErrorResponse } from '@/utils/axios.http';

export const useGetFirstGlobalEmailSetting = () => {
  return useQuery({
    queryKey: ['getFirstGlobalEmailSetting'],
    queryFn: () => getFirstGlobalEmailSetting(),
  });
};

export const useUpsertGlobalEmailSetting = ({
  t,
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (globalEmailSetting: TGlobalEmailSettingSchema) =>
      upsertGlobalEmailSetting(globalEmailSetting),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['getFirstGlobalEmailSetting'],
      });

      notify(t('common:settingUpdatedSuccessfully'), NOTIFY.SUCCESS);

      handleSuccess?.();
    },
    onError: (error: ErrorResponse) => {
      notify(t('common:errorOccurredTryAgainLater'), NOTIFY.ERROR);
      console.error('Error when updating global email setting:', error);
    },
  });
};
